import React from "react";
import Grid from "@material-ui/core/Grid";
import { useStyles } from "./style";
import GeneralStats from "./components/GeneralStats";
import TopOrgs from "./components/TopOrgs";
import TopUsers from "./components/TopUsers";
import TopConsecutiveUsers from "./components/TopConsecutiveUsers";

export default function Dashboard() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {/* <GeneralStats />
      <br></br> */}
      <TopOrgs />
      {/* <br></br> */}
      {/* <Grid container spacing={2}>
        <Grid item xs={6}>
          <TopUsers />
        </Grid>
        <Grid item xs={6}>
          <TopConsecutiveUsers />
        </Grid>
      </Grid> */}
    </div>
  );
}
